module.exports = __webpack_public_path__ + "static/media/green_circle.3f79a519.svg";